import { render, staticRenderFns } from "./TcLegal.vue?vue&type=template&id=7a4e6e8a&"
import script from "./TcLegal.vue?vue&type=script&lang=js&"
export * from "./TcLegal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/inventia/Sites/coiico_totem/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a4e6e8a')) {
      api.createRecord('7a4e6e8a', component.options)
    } else {
      api.reload('7a4e6e8a', component.options)
    }
    module.hot.accept("./TcLegal.vue?vue&type=template&id=7a4e6e8a&", function () {
      api.rerender('7a4e6e8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TcLegal.vue"
export default component.exports